










































import { FacilityModel } from "@/app/models/facility.model"
import { defineComponent } from "@vue/composition-api"

import "swiper/css/swiper.css"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
  setup() {
    const swiperComponentOption = {
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      lazy: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        1920: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    }
    const swiper = new Swiper(swiperComponentOption)

    return {
      swiperComponentOption,
      swiper,
    }
  },
})
